import HttpResponse from "@/store/models/httpResponse";
import HttpException from "@/store/models/httpException";

const defaultBaseUrl = process.env.NODE_ENV === "production"
  ? "https://core-api.fromyouflowers.com/"
  : "https://localhost:5101/";

export default class HttpClient {
  _timeout = 10000;

  constructor(baseUrl) {
    this._baseUrl = baseUrl ?? defaultBaseUrl;
  }

  get(path, successCallback, errorCallback) {
    this._doRequest(path)
      .then(successCallback)
      .catch(errorCallback);
  }

  async _doRequest(path, options = {}) {
    const signal = AbortSignal.timeout(this._timeout);
    const fullUrl = `${this._baseUrl}${path}`;

    let rawResponse;
    try {
      rawResponse = await fetch(fullUrl, {
        ...options,
        signal,
      });
    } catch (error) {
      throw new HttpException(error);
    }

    const data = await this._getJsonBody(rawResponse);
    const headers = Object.fromEntries(rawResponse.headers.entries());

    const formattedResponse = new HttpResponse(
      data ?? {},
      rawResponse.status,
      rawResponse.statusText,
      headers,
    );

    if (!rawResponse.ok) {
      throw new HttpException(formattedResponse);
    }

    if (data === null) {
      throw new HttpException(`Failed to parse JSON response from ${fullUrl}`);
    }

    return formattedResponse;
  }

  async _getJsonBody(rawResponse) {
    try {
      return await rawResponse.json();
    } catch (_) {
      return null;
    }
  }
}
